import { ListItem } from '../ListItem'
import { UserListItemContent } from '../UserListItemContent'

import * as styles from './UserListItem.module.css'

function UserListItem({
  Content = UserListItemContent,
  className = styles.UserListItem,
  hoverClassName = null,
  ...restProps
}) {
  return (
    <ListItem
      {...restProps}
      Content={Content}
      className={className}
      hoverClassName={hoverClassName}
    />
  )
}

export default UserListItem
